module.exports = __webpack_public_path__ + "static/media/sms-new.5de6375c.svg";